import { useContext } from 'react';
import { SocketContext } from '../context/SocketContext';

/**
 * Hook to access the socket context
 * @returns {{ socket: Socket | null, isConnected: boolean, connectionError: string | null }}
 */
export const useSocket = () => {
  const context = useContext(SocketContext);
  if (!context) {
    throw new Error('useSocket must be used within a SocketProvider');
  }
  return context;
};
